/**
 * Helper functions for Google Forms integration
 */

// Your actual Google Form ID
const GOOGLE_FORM_ID = '1FAIpQLSehcilCV6ENmh2IkQVEVQ0kmk9f_ZPdYS6Nv0lV2xnw11R6Ag';

/**
 * Open the Google Form directly in a new tab
 * This is the simplest approach that always works
 */
export const openGoogleForm = () => {
  console.log("Opening Google Form in new tab");
  window.open(`https://docs.google.com/forms/d/e/${GOOGLE_FORM_ID}/viewform`, '_blank');
};

// Keep these functions for potential future use
export const FIELD_IDS = {
  name: 'entry.1234567890', // Replace with actual entry ID
  adultsCount: 'entry.1234567891', // Replace with actual entry ID
  kidsCount: 'entry.1234567892', // Replace with actual entry ID
  address: 'entry.1234567893', // Replace with actual entry ID
  eventTitle: 'entry.1234567894' // Replace with actual entry ID
};

/**
 * Get the Google Form submission URL
 * @returns {string} The URL for form submission
 */
export const getGoogleFormURL = () => {
  return `https://docs.google.com/forms/d/e/${GOOGLE_FORM_ID}/formResponse`;
};

/**
 * Get a prefilled Google Form URL that can be opened in a new tab
 * This is an alternative approach if direct form submission doesn't work due to CORS
 * 
 * @param {Object} formData The form data to prefill
 * @param {string} formData.name Full name
 * @param {number} formData.adultsCount Number of adults
 * @param {number} formData.kidsCount Number of kids
 * @param {string} formData.address Home address
 * @param {string} formData.eventTitle Event title
 * @returns {string} URL with prefilled form data
 */
export const getPrefilledFormURL = (formData) => {
  const baseURL = `https://docs.google.com/forms/d/e/${GOOGLE_FORM_ID}/viewform?`;
  
  const params = new URLSearchParams();
  
  // Add each form field to the URL parameters
  Object.entries(formData).forEach(([key, value]) => {
    if (value && FIELD_IDS[key]) {
      params.append(FIELD_IDS[key], value.toString());
    }
  });
  
  return baseURL + params.toString();
};

/**
 * Submit form data to Google Forms
 * Note: This may not work directly due to CORS restrictions
 * 
 * @param {Object} formData The form data to submit
 * @returns {Promise} A promise that resolves when the form is submitted
 */
export const submitToGoogleForm = async (formData) => {
  const submitData = new FormData();
  
  // Add each form field to the FormData object
  Object.entries(formData).forEach(([key, value]) => {
    if (value !== undefined && value !== null && FIELD_IDS[key]) {
      submitData.append(FIELD_IDS[key], value.toString());
    }
  });
  
  // Submit the form using no-cors mode
  // This won't give us a response we can read, but it will submit the form
  return fetch(getGoogleFormURL(), {
    method: 'POST',
    mode: 'no-cors',
    body: submitData
  });
}; 